import { render, staticRenderFns } from "./GroupCEOaward.vue?vue&type=template&id=f1f77386&"
import script from "./GroupCEOaward.vue?vue&type=script&lang=js&"
export * from "./GroupCEOaward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports